import React from 'react';
import Page from '../Containers/Page';
import NewId from '../../utils/NewId';

class FullWidthPage extends React.Component {

    renderSection(section) {
        let sec;
        if (section.type !== 'section') {
            sec = <div className={section.props.className ? section.props.className: "col-md-12"}>
                {section}
            </div>;
        }
        else {
            sec = section
        }

        return <div key={NewId('section')} className="container">
            <div className="row">
                {sec}
            </div>
        </div>
    }

    render() {
        let {children, title} = this.props;
        children = Array.isArray(children) ? children : [children];

        return <Page title={title}>
            {children.map((section) => this.renderSection(section))}
        </Page>
    }
}

export default FullWidthPage;


// WEBPACK FOOTER //
// ./src/components/Presentation/FullWidthPage.js